export const minimumHeight = 1050;
export const minimumWidth = 1750;
export const timeToCompleteTask = 1000 * 60 * 10;
